import FormattedMessage from 'I18n/components/FormattedMessage';
import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { useCallback } from 'react';
import EnrollExistingSection from 'automation-ui-canvas/containers/review/EnrollExistingSection';
import EnrollmentReviewSection from 'automation-ui-canvas/containers/review/EnrollmentReviewSection';
import UnenrollmentReviewSection from 'automation-ui-canvas/containers/review/UnenrollmentReviewSection';
import ReenrollmentReviewSection from 'automation-ui-canvas/containers/review/ReenrollmentReviewSection';
import { initialEnrollmentState } from 'automation-ui-canvas/components/flow-header/menu-bar/menuOptions/constants/EnrollExistingState';
import { getIsObjectlessFlow } from 'automation-ui-flow-core/flow/flowUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EnrollmentStep = ({
  flow,
  setModalState,
  modalState
}) => {
  const enrollExistingState = modalState.get('enrollExistingState') || initialEnrollmentState;
  const setEnrollExistingState = useCallback(newState => {
    setModalState(prev => prev.set('enrollExistingState', newState));
  }, [setModalState]);
  const isObjectlessFlow = getIsObjectlessFlow(flow.toHybridFlowInterface());
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EnrollExistingSection, {
      flow: flow,
      enrollExistingState: enrollExistingState,
      setEnrollExistingState: setEnrollExistingState
    }, flow.version), !isObjectlessFlow && /*#__PURE__*/_jsx(UITile, {
      compact: true,
      style: {
        borderTopStyle: 'none'
      },
      children: /*#__PURE__*/_jsxs(UITabs, {
        defaultSelected: "enrollment",
        panelClassName: "p-x-0",
        use: "enclosed",
        hideBorders: "both",
        fill: true,
        children: [/*#__PURE__*/_jsx(UITab, {
          tabId: "enrollment",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformReview.v2.enrollmentStep.tabs.enrollment"
          }),
          children: /*#__PURE__*/_jsx(UITileSection, {
            className: "p-bottom-0 m-top-2",
            children: /*#__PURE__*/_jsx(EnrollmentReviewSection, {
              flow: flow
            })
          })
        }), /*#__PURE__*/_jsx(UITab, {
          tabId: "unenrollment",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformReview.v2.enrollmentStep.tabs.unenrollment"
          }),
          children: /*#__PURE__*/_jsx(UITileSection, {
            children: /*#__PURE__*/_jsx(UnenrollmentReviewSection, {
              flow: flow
            })
          })
        }), /*#__PURE__*/_jsx(UITab, {
          tabId: "reenrollment",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformReview.v2.enrollmentStep.tabs.reenrollment"
          }),
          children: /*#__PURE__*/_jsx(UITileSection, {
            children: /*#__PURE__*/_jsx(ReenrollmentReviewSection, {
              flow: flow
            })
          })
        })]
      })
    })]
  });
};
export default EnrollmentStep;